export const REMOTE_SERVER_URL = 'https://api.vektor.club'
